var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import cn from "classnames";
import { bem } from "@react-md/utils";
var block = bem("rmd-toggle-container");
/**
 * The `ToggleContainer` component should generally be used around a
 * custom `"checkbox"`, `"radio"`, or `"switch"` component to help with
 * additional styles. This is mostly an internal component so I'm not
 * sure useful it will be though.
 */
export var ToggleContainer = forwardRef(function ToggleContainer(_a, ref) {
    var className = _a.className, _b = _a.inline, inline = _b === void 0 ? false : _b, _c = _a.stacked, stacked = _c === void 0 ? false : _c, children = _a.children, props = __rest(_a, ["className", "inline", "stacked", "children"]);
    return (_jsx("div", __assign({}, props, { ref: ref, className: cn(block({ stacked: stacked, inline: inline }), className) }, { children: children })));
});
//# sourceMappingURL=ToggleContainer.js.map